export default () => new Promise((resolve, reject) => {
  if (typeof $().slick === 'function') {
    resolve();

    return;
  }

  import(/* webpackChunkName: "slick" */ 'slick-carousel')
    .then(resolve)
    .catch(reject);
});
